import { BoxProps, ColorOptions, TextInputNewProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const styles = (): any => {
  return {
    container: {
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: 'LIGHT_GREY',
      borderRadius: 4,
      zIndex: 4,
      backgroundColor: '#FFFFFF',
      height: '100vh',
      width: 650,
      overflow: 'auto',
    } as ViewStyle,
    headerContainer: {
      // flex: 1,
      padding: 0,
      margin: 24,
      marginRight: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      //   ...overRideHeaderContainer,
    } as BoxProps,
    ernContainer: {
      // flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      alignSelf: 'center',
      margin: 0,
      paddingRight: 10,
      width: '50%',
      //   ...overRideErnContainer,
    } as BoxProps,
    textinputStyle: (isEditMode: boolean) =>
      ({
        type: 'body12',
        borderColor: isEditMode ? ('#E0E0E0' as ColorOptions) : 'WHITE',
        labelPaddingBottom: 8,
        borderRadius: isEditMode ? 4 : 0,
        labelFontFamily: 'jiotype-bold',
        fontFamily: 'jiotype-medium',
        labelColor: '#757575' as ColorOptions,
        labelFontSize: 12,
        fontSize: 12,
        selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
        paddingVertical: 8,
        color: 'BLACK_21' as ColorOptions,
        onFocusBorderWidth: isEditMode ? 1 : 0,
      } as unknown as TextInputNewProps),
  }
}

export { styles }
